import React from 'react'
import './MembershipTab.scss'
import {addToCart, clearCart} from "@/services/cart";
import {v4 as uuidV4} from "uuid";
import {ROUTESLIST} from "@/static/urls";
import history from "@/store/history";
import {oneTimePlans} from '@/utils/constants';
import MembershipTiles from "@/components/MembershipTiles/MembershipTiles";

const MembershipTab = () => {
    const from = history.location?.state?.from;
    const addSample = () => {
        const getSingleSample = oneTimePlans.find(
            (plan) => plan.id === "full-clearance-package"
        );
        if (getSingleSample) {
            // Base product only — the server applies the membership discount and spends the credit.
            getSingleSample.product_type = 'sample';
            addToCart(getSingleSample);
        }
    }
    const addPlan = () => {
        if (from === 'add-sync' || from === 'add-sample') {
            addSample();
        }
    }
    const addMembership = () => {
        clearCart();
        addPlan();
        addToCart({
            id: uuidV4(),
            name: 'Membership',
            price: 500,
            description: 'The Ample Samples Membership',
            priceId: 'price_1SRzNUDOERxX1mfPcgkd9rq6',
            slug: 'pro',
            product_type: 'membership'
        })
        // 4. Go to checkout!
        history.push(ROUTESLIST.CHECKOUT, {from: from});
    }

    return (
        <>
            <MembershipTiles sectionTitle="Choose your membership"/>

            {/*<div className="membership-tab">
                 eslint-disable-next-line jsx-a11y/accessible-emoji
                <h3 className="membership-tab__title">💰 Ample Samples Membership vs. Non-Membership Pricing</h3>

                <div className="membership-tab__table-wrap">
                    <table className="membership-tab__table">
                        <thead className="membership-tab__head">
                        <tr>
                            <th className="membership-tab__th">Scenario</th>
                            <th className="membership-tab__th">Membership Fee</th>
                            <th className="membership-tab__th">Cost per Clearance</th>
                            <th className="membership-tab__th">Number of Clearances</th>
                            <th className="membership-tab__th">Total Cost</th>
                            <th className="membership-tab__th">Total Savings</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td className="membership-tab__td">With Membership</td>
                            <td className="membership-tab__td">$500</td>
                            <td className="membership-tab__td">$1,000</td>
                            <td className="membership-tab__td">15</td>
                            <td className="membership-tab__td">
                                <strong>$15,500</strong> <span
                                className="membership-tab__muted">( $500 + $15,000 )</span>
                            </td>
                            <td className="membership-tab__td"><strong>$7,000</strong> saved</td>
                        </tr>
                        <tr>
                            <td className="membership-tab__td">Without Membership</td>
                            <td className="membership-tab__td">—</td>
                            <td className="membership-tab__td">$1,500</td>
                            <td className="membership-tab__td">15</td>
                            <td className="membership-tab__td"><strong>$22,500</strong></td>
                            <td className="membership-tab__td">—</td>
                        </tr>
                        </tbody>
                    </table>
                    <button className="purchase-button" onClick={() => addMembership()}>
                        Purchase Membership
                    </button>
                </div>
            </div>*/}
        </>
    )
}

export default MembershipTab;